import React from 'react';
import { X } from 'lucide-react';
import { supabase } from '../utils/supabase';

interface DeactivateDoubleModalProps {
  double: {
    id: string;
    name: string;
  };
  onClose: () => void;
  onDeactivate: (id: string) => void;
}

const DeactivateDoubleModal = ({ double, onClose, onDeactivate }: DeactivateDoubleModalProps) => {
  const handleDeactivate = async () => {
    try {
      const { error } = await supabase
        .from('doubles')
        .update({ status: 'inactive' })
        .eq('id', double.id);

      if (error) throw error;
      onDeactivate(double.id);
      onClose();
    } catch (error) {
      console.error('Error deactivating double:', error);
    }
  };

  return (
    <div 
      className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4"
      onClick={onClose}
    >
      <div 
        className="bg-white w-full max-w-md rounded-xl shadow-retro border-2 border-dark"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="p-6 border-b border-gray-200 flex items-center justify-between">
          <h2 className="text-2xl font-bold text-gray-900">Deactivate Double</h2>
          <button
            onClick={onClose}
            className="p-2 hover:bg-gray-100 rounded-lg transition-colors"
          >
            <X className="h-5 w-5" />
          </button>
        </div>
        
        <div className="p-6">
          <p className="text-gray-600 mb-6">
            Are you sure you want to deactivate {double.name}? This will remove them from your active doubles.
          </p>
          
          <div className="flex justify-end gap-3">
            <button
              onClick={onClose}
              className="px-4 py-2 text-gray-700 hover:bg-gray-100 rounded-lg transition-colors"
            >
              Nevermind
            </button>
            <button
              onClick={handleDeactivate}
              className="px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 transition-colors"
            >
              Trade 'em
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DeactivateDoubleModal;